const iconPaths = {
  tooth: (
    <>
      <path d="M7.4 4.7c1.4-1 2.9-.7 4.6.1 1.7-.8 3.2-1.1 4.6-.1 2 1.4 1.9 4.5.8 6.8-.7 1.6-.9 3.1-1.1 4.6-.3 2-.9 3.2-2.1 3.2-.9 0-1.3-.9-1.7-2.1-.3-.9-.5-1.5-1.1-1.5s-.8.6-1.1 1.5c-.4 1.2-.8 2.1-1.7 2.1-1.2 0-1.8-1.2-2.1-3.2-.2-1.5-.4-3-1.1-4.6-1.1-2.3-1.2-5.4.8-6.8Z" />
      <path d="M9 7.3c.8.4 1.7.6 3 .6s2.2-.2 3-.6" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 4.2 13.7 9l4.9 1.8-4.9 1.7-1.7 4.9-1.8-4.9-4.8-1.7L10.2 9 12 4.2Z" />
      <path d="M18.5 4.8v3" />
      <path d="M20 6.3h-3" />
      <path d="M5.5 16.2v2.6" />
      <path d="M6.8 17.5H4.2" />
    </>
  ),
  implant: (
    <>
      <path d="M10 4h4l1.2 3.4H8.8L10 4Z" />
      <path d="M9.2 7.4h5.6v3.2H9.2z" />
      <path d="M10.2 10.6h3.6l-.5 9.2h-2.6l-.5-9.2Z" />
      <path d="M10.6 13.2h2.8" />
      <path d="M10.8 15.8h2.4" />
    </>
  ),
  braces: (
    <>
      <path d="M4.5 10.8h15" />
      <path d="M6 8.5h3v4.6H6z" />
      <path d="M10.5 8.5h3v4.6h-3z" />
      <path d="M15 8.5h3v4.6h-3z" />
      <path d="M7.5 13.1v2.4" />
      <path d="M12 13.1v2.4" />
      <path d="M16.5 13.1v2.4" />
    </>
  ),
  emergency: (
    <>
      <path d="M12 5.2v13.6" />
      <path d="M5.2 12h13.6" />
      <path d="M6.6 6.6c3-3 7.8-3 10.8 0s3 7.8 0 10.8-7.8 3-10.8 0-3-7.8 0-10.8Z" />
    </>
  ),
  child: (
    <>
      <path d="M7.6 5c1.3-.9 2.8-.7 4.4 0 1.6-.7 3.1-.9 4.4 0 1.8 1.3 1.8 4.2.8 6.4-.6 1.4-.8 2.7-1 4-.3 1.8-.8 2.9-1.9 2.9-.8 0-1.2-.8-1.5-1.9-.3-.8-.5-1.3-.8-1.3s-.5.5-.8 1.3c-.3 1.1-.7 1.9-1.5 1.9-1.1 0-1.6-1.1-1.9-2.9-.2-1.3-.4-2.6-1-4-1-2.2-1-5.1.8-6.4Z" />
      <path d="M9 10.8c1.7 1.5 4.3 1.5 6 0" />
    </>
  )
};

export function getTreatmentIconType(slug) {
  const iconByTreatment = {
    preventive: 'tooth',
    restorative: 'tooth',
    cosmetic: 'sparkle',
    implants: 'implant',
    emergency: 'emergency',
    children: 'child'
  };

  return iconByTreatment[slug] || 'tooth';
}

export function getServiceIconType(title, treatmentSlug) {
  const normalized = title.toLowerCase();

  if (normalized.includes('implant') || normalized.includes('bone')) return 'implant';
  if (normalized.includes('brace') || normalized.includes('aligner')) return 'braces';
  if (normalized.includes('whitening') || normalized.includes('smile') || normalized.includes('veneer') || normalized.includes('bonding')) return 'sparkle';
  if (normalized.includes('pain') || normalized.includes('abscess') || normalized.includes('emergency') || normalized.includes('trauma') || normalized.includes('swelling')) return 'emergency';
  if (normalized.includes('child') || normalized.includes('kid')) return 'child';

  return getTreatmentIconType(treatmentSlug);
}

export default function ServiceIcon({ type = 'tooth', className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        {iconPaths[type] || iconPaths.tooth}
      </g>
    </svg>
  );
}
